export default {
  "cycleProFeature": {
    "title": "Función de ciclo profesional",
    "description": "Puede usar esta función u otras funciones completas activando Pro Cycle.",
    "more": "Saber más"
  },
  "dateTimeFilter": {
    "dateAfter": "fecha posterior",
    "dateBefore": "Fecha anterior",
    "time": "Tiempo",

    "all": "Todos",
    "am": "AM",
    "pm": "PM",

    "apply": "Aplicar",
    "reset": "Reiniciar",
  },
  "multipleImageInput": {
    "camera": "Cámara",
    "image": "Galería"
  },
  "onboardNewFeatureModal": {
    "showFeature": "Mostrar Características",
    "skipFeature": "cerrar",
    "newFeature": "Nueva caracteristica",
    "titleFeature1": "Monitoreo de costos",
    "textFeature1": "Supervise las estimaciones de costos operativos todos los días como una alternativa a la evaluación de posibles ganancias/pérdidas.",
    "titleFeature2": "Cuadro de costos operativos",
    "textFeature2": "Visualización gráfica estimada para facilitar la visualización de posibles ganancias/pérdidas hasta el final del ciclo.",
    "contentOverview": "Desliza esta área para ver el valor de los costos/operaciones agrícolas.",
    "contentItemOverview": "Seleccione una casilla para ver detalles por grupo.",
    "contentTabOverview": "Puede ver otra información más rápidamente a través de pestañas.",
    "contentGraphOverview": "También puede ver la tendencia de costos en el menú del gráfico.",
    "contentTabGraphOverview": "¡Nueva caracteristica!\nGráficos para el seguimiento de costes.",
    "contentItemGraphOverview": "Lea los costos estimados a través del gráfico, también puede desplazarse hacia abajo para ver otros gráficos.",
    "contentFilterGraphOverview": "Vea más gráficos más rápido a través de este filtro.",
  },
  "onboardModal": {
    "welcomeTitle": "Bienvenidos a JALA",
    "welcomeDescription": "Siga las instrucciones para comenzar su viaje de cultivación.",
    "welcomeAction": "Siga Las Instrucciones",
    "welcomeSkipAction": "Saltar por Ahora",
    "welcomeBanner": "Si eres agricultor, cambia al modo de cultivo",
    "welcomeMenuOther": "Descubre otros servicios para aprender sobre cultivo y experimentar simulaciones de cultivo.",
    "welcomeOverview": "Monitorea todos los datos principales de tus estanques aquí.",
    "welcomeOverviewCreateSomething": "Inicia tu viaje de cultivo creando %{something}",
    "welcomeMenu": "Explora otros servicios que te ayudarán en tu viaje de cultivo.",
    "welcomeHome": "",
    "welcomeQuickInput": "Ingresa tus datos de cultivo aquí.",
    "welcomeActivity": "Administra las actividades diarias sin temor a perderte nada.",
    "welcomeMonitoring": "Analice sus estanques aquí.",


    "consultationTitle": "Ahora puedes hacer Consulta de Cultivo",
    "consultationDescription": "Tienes problemas en la agricultura? Consultemos su problema con los expertos de Jala.",

    "newMenuTitle": "¡Nuevo! Entrada de actividad diaria",
    "newMenuSubtitle": "Como recordatorio en el registro del cultivo todos los días."
  },
  "offlineMode": {
    "resetRequireInternet": "Restablecer requiere conectividad a Internet",
  },
  "shrimpPriceFilter": {
    "country": "País",
    "region": "Provincia",
    "time": "Actualizaciones de Precios",
    "supplier": "Proveedor",

    "regionLabel": "Seleccione Provincia",
    "timeLabel": "Seleccione Actualizaciones de Precios",

    "now": "Más Reciente",
    "week": "> 1 Semana",
    "month": "> 1 Mes",

    "all": "Todos",
    "verified": "Verificado",

    "apply": "Aplicar",
    "reset": "Reiniciar",
  },
  "listEmpty": {
    "text": "No hay datos guardados todavía"
  },
  "listNetworkError": {
    "refreshPage": "Actualice La Página"
  },

  "astoCoachmark": {
    "connection": "Indicador de Asto ha sido conectado por Bluetooth o Wifi o no",
    "resetButton": "Restablecer para devolver los cambios a su estado original",
    "saveButton": "Puedes usar la función 'Guardar' antes de subirlo",
    "uploadButton": "Sube los datos que has ingresado",
    "feedTable": "Puede usar los datos que se han ingresado en la función de entrada de feed",
    "todayFeed": "Ingrese la alimentación total en un día",
    "todayFeedNormal": "Ajustar la ración con las horas de alimentación en el estanque",
    "nextDayFeed": "También puede agregar los datos del feed durante una semana.",
  }
}
